import { withMetadata } from '../metadata'
import { getExampleNumber as _getExampleNumber } from '../../core/index'

export function getExampleNumber() {
	return withMetadata(_getExampleNumber, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/min/exports/getExampleNumber.js
// module id = 637
// module chunks = 0